// assets/predictive-search.js
(function () {
  // Helpers
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  const input = $('#search-input');
  const suggestionRoot = $('#predictive-suggestions');
  const suggestionLeft = $('#predictive-suggestion-left');
  const suggestionRight = $('#predictive-suggestion-right');
  const viewAllLink = $('#predictive-view-all');
  const toast = $('#predictive-toast');

  if (!input) return;

  let debounceTimer = null;

  // Debounce & fetch suggestions
  input.addEventListener('input', function (e) {
    clearTimeout(debounceTimer);
    const q = this.value.trim();

    if (q.length < 2) {
      suggestionRoot.style.display = 'none';
      return;
    }

    debounceTimer = setTimeout(() => {
      fetchSuggestions(q);
    }, 300);
  });

  // Hide when clicking outside
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.predictive-search-root')) {
      suggestionRoot.style.display = 'none';
    }
  });

  // Show suggestions when focusing if there is text
  input.addEventListener('focus', function () {
    if (this.value.trim().length >= 2 && suggestionRight.innerHTML.trim() !== '') {
      suggestionRoot.style.display = 'block';
    }
  });

  async function fetchSuggestions(query) {
    try {
      const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`;
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('Suggestion fetch failed');
      const data = await res.json();

      const products = data?.resources?.results?.products || [];

      renderSuggestions(products, query);
    } catch (err) {
      console.error('Predictive search error:', err);
      suggestionRoot.style.display = 'none';
    }
  }

  function safeImgUrl(product) {
    // try multiple shapes returned by different themes / API versions
    if (!product) return '';
    if (product.featured_image && typeof product.featured_image === 'object') {
      return product.featured_image.url || product.featured_image.src || '';
    }
    if (product.featured_image && typeof product.featured_image === 'string') {
      return product.featured_image;
    }
    if (product.image) return product.image;
    return '';
  }

  function handleProductUrl(product) {
    if (product.url) return product.url;
    if (product.handle) return `/products/${product.handle}`;
    // fallback: try to extract from url path if present
    if (product.handle) return `/products/${product.handle}`;
    return '#';
  }

  function renderSuggestions(products, query) {
    // LEFT: small keyword/title suggestions
    let leftHTML = '';
    if (products.length > 0) {
      leftHTML += `<div class="sailec-normal font18 spacing_036 leading26 text-black mb-2 res-font16 res-spacing_032">Suggestions</div><ul class="list-none ps-0 mb-0">`;
      products.forEach((p) => {
        const href = handleProductUrl(p);
        const title = escapeHtml(p.title);

        // highlight only the matching part
        let highlightedTitle = title;
        if (query) {
          const regex = new RegExp(`(${query})`, 'gi'); // case-insensitive
          highlightedTitle = title.replace(regex, `<span class="text-black">$1</span>`);
        }

        leftHTML += `<li>
    <a 
      class="sailec-normal font14 spacing_028 leading34 text-717171 text-decoration-none transition predictive-suggestion-key" 
      href="${href}">
      ${highlightedTitle}
    </a>
  </li>`;
      });

      leftHTML += '</ul>';
    } else {
      leftHTML = `<div class="sailec-normal font18 spacing_036 leading26 text-black mb-2">No suggestions</div>`;
    }

    suggestionLeft.innerHTML = leftHTML;

    // ---- keep your RIGHT rendering code unchanged ----
    let rightHTML = `<div class="sailec-normal font18 spacing_036 leading26 text-black mb-3 search-card-content-heading res-font15 res-spacing_03">Results for “${escapeHtml(
      query
    )}”</div>`;
    rightHTML += `<div class="search-card-content overflow-hidden col-lg-10 px-lg-3"><div class="row row17">`;

    if (products.length === 0) {
      rightHTML += `<div class="col-12">No products found.</div>`;
    } else {
      products.forEach((p) => {
        const img = safeImgUrl(p) || '/assets/no-image-available.png';
        const title = p.title || '';
        const desc = (p.body || p.description || '').replace(/(<([^>]+)>)/gi, '').slice(0, 80);
        const price = p.price ? formatPriceFromCents(p.price) : '';
        const handle = p.handle || (p.url ? p.url.split('/products/')[1] : '');
        const productUrl = handleProductUrl(p);

        rightHTML += `
        <div class="col-xl-6 col-lg-5 col-sm-6 col-12 mb-4">
          <div class="result-card p-3">
            <div class="row g-0 align-items-center">
              <div class="mega-img">
                <a href="${productUrl}">
                  <img class="w-100 h-100 object-fit-cover" src="${img}" alt="${escapeHtml(title)}">
                </a>
              </div>
              <div class="col-8 ms-3">
                <a href="${productUrl}" class="text-decoration-none">
                <div class="sailec-medium font14 spacing_028 leading26 text-black mb-1 res-font12 res-leading20 res-spacing_024">${escapeHtml(
                  title
                )}</div>
                </a>
                <a href="${productUrl}" class="sailec-light text-decoration-none font14 spacing_028 leading20 text-717171 mb-2 res-font12 res-leading16 res-spacing_024">${escapeHtml(
                  desc
                )}</a>
                <div class="d-flex justify-content-between align-items-center flex-row-reverse flex-lg-row">
                  <div class="sailec-medium font14 spacing_028 leading26 text-black res-font12 res-leading20 res-spacing_024">${price}</div>
                  <button class="sailec-medium font12 spacing_024 leading30 text-black predictive-add-btn bg-transparent border-0 text-decoration-underline res-font12 res-leading20 res-spacing_024" data-handle="${escapeHtml(
                    handle
                  )}">ADD TO BAG</button>
                </div>
              </div>
            </div>
          </div>
        </div>`;
      });
    }

    rightHTML += `</div></div>`;
    suggestionRight.innerHTML = rightHTML;

    // View all results link (search page)
    viewAllLink.href = `/search?q=${encodeURIComponent(query)}`;

    // show panel
    suggestionRoot.style.display = 'block';

    // attach add-to-bag listeners
    $$('.predictive-add-btn', suggestionRight).forEach((btn) => {
      btn.addEventListener('click', async function (e) {
        e.preventDefault();
        const handle = this.dataset.handle;
        if (!handle) return showToast('Unable to add product.');
        this.disabled = true;
        this.textContent = 'Adding...';
        try {
          await addToCartByHandle(handle);
          this.textContent = 'Added';
          setTimeout(() => {
            this.textContent = 'ADD TO BAG';
          }, 1500);
        } catch (err) {
          console.error(err);
          showToast('Unable to add product. Try again.');
          this.textContent = 'ADD TO BAG';
        } finally {
          this.disabled = false;
        }
      });
    });
  }

  async function addToCartByHandle(handle) {
    try {
      // fetch product JSON to get a variant id (first/default variant)
      const productRes = await fetch(`/products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin' });
      if (!productRes.ok) throw new Error('Failed to fetch product details');
      const productJson = await productRes.json();
      const variantId = productJson?.variants?.[0]?.id;
      if (!variantId) throw new Error('No variant found');

      // add to cart via AJAX
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });
      if (!addRes.ok) {
        const errText = await addRes.text();
        console.error('Add to cart error text:', errText);
        throw new Error('Add to cart failed');
      }
      const added = await addRes.json();

      // ✅ Update cart count AND refresh drawer without page reload
      updateCartAndDrawer();

      // showToast(`${productJson.title} added to cart`);
      showToast('Added to bag!');

      return added;
    } catch (err) {
      console.error('addToCartByHandle error:', err);
      throw err;
    }
  }

  // Updated function: fetch cart + refresh drawer
  function updateCartAndDrawer() {
    fetch('/cart.js')
      .then((res) => res.json())
      .then((cart) => {
        // Update header counter
        const cartNumberElems = document.querySelectorAll('.cart-number');
        cartNumberElems.forEach((el) => (el.textContent = cart.item_count));

        // Refresh drawer
        fetch('/cart')
          .then((res) => res.text())
          .then((data) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(data, 'text/html');
            const newDrawerInner = doc.querySelector('.drawer__inner');
            const drawerInner = document.querySelector('.drawer__inner');
            if (newDrawerInner && drawerInner) {
              drawerInner.innerHTML = newDrawerInner.innerHTML;

              const cartDrawer = document.querySelector('.drawer');
              if (cartDrawer) {
                if (cart.item_count > 0) {
                  cartDrawer.classList.remove('is-empty');
                } else {
                  cartDrawer.classList.add('is-empty');
                }
              }
            }
          });
      });
  }

  // ✅ Toast Notification
  function showToast(msg, error = false) {
    const toast = document.createElement('div');
    toast.className = 'cart-toast' + (error ? ' error' : '');
    toast.textContent = msg;

    document.body.appendChild(toast);

    // Show toast
    toast.style.opacity = '1';
    toast.style.transition = 'opacity 0.4s';

    setTimeout(() => {
      toast.style.opacity = '0';
      setTimeout(() => {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 400);
    }, 2000);
  }

  // utils
  function formatPriceFromCents(value) {
    try {
      const num = Number(value);

      // Shopify Predictive Search already returns price in proper decimal format (like 64.00)
      // But fallback for other APIs that might still return cents
      const amount = num > 1000 ? (num / 100).toFixed(2) : num.toFixed(2);

      return `£${amount}`;
    } catch (e) {
      return '';
    }
  }

  function escapeHtml(text) {
    if (!text) return '';
    return String(text).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }

  // async function updateCartCount() {
  //   try {
  //     const res = await fetch('/cart.js', { credentials: 'same-origin' });
  //     if (!res.ok) return;
  //     const cart = await res.json();
  //     const count = cart.item_count || 0;
  //     // try to update an element with id or data attr
  //     const counter = document.getElementById('cart-count') || document.querySelector('[data-cart-count]');
  //     if (counter) counter.textContent = count;
  //   } catch (err) {
  //     // ignore
  //   }
  // }

  // small toast
  // function showToast(msg, timeout = 3000) {
  //   if (!toast) return;
  //   toast.textContent = msg;
  //   toast.style.display = 'block';
  //   toast.style.opacity = '1';
  //   setTimeout(() => {
  //     toast.style.opacity = '0';
  //     setTimeout(() => (toast.style.display = 'none'), 400);
  //   }, timeout);
  // }
})();
